/**
 * Shared formatting for the rewards views.
 *
 * Points are whole numbers and money is rupees — the two are never mixed in one figure,
 * because "₹165 of points" and "165 points" mean different things to the person reading
 * a liability report.
 */

export const pts = (n) => `${Math.max(0, Math.trunc(Number(n) || 0)).toLocaleString('en-IN')}`;

export const inr = (n) => `₹${(Math.round((Number(n) || 0) * 100) / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;

export const paiseToInr = (p) => inr((Number(p) || 0) / 100);

export const dateIn = (ms) => (ms ? new Date(Number(ms)).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—');

export const dateTimeIn = (ms) => (ms
    ? new Date(Number(ms)).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: '2-digit', hour: '2-digit', minute: '2-digit' })
    : '—');

/** "in 5 days" / "today" / "3 days ago" — relative, because expiry is read as urgency. */
export const daysFrom = (ms) => {
    if (!ms) return '';
    const d = Math.ceil((Number(ms) - Date.now()) / 86400000);
    if (d === 0) return 'today';
    return d > 0 ? `in ${d} day${d === 1 ? '' : 's'}` : `${-d} day${d === -1 ? '' : 's'} ago`;
};

/** Mobile as 98765 43210 — grouped the way an Indian number is read aloud. */
export const mobile10 = (k) => {
    const s = String(k || '').replace(/\D/g, '').slice(-10);
    return s.length === 10 ? `${s.slice(0, 5)} ${s.slice(5)}` : (s || '—');
};

/** Ledger entry → what a person should see in a history list. */
export const LEDGER_LABEL = {
    credit: 'Points earned',
    reserve: 'Held for an order',
    redeem: 'Points redeemed',
    release: 'Hold released',
    restore: 'Points returned',
    reverse: 'Points reversed',
    expire: 'Points expired',
};

export const SOURCE_LABEL = {
    earned: 'Earned',
    promotional: 'Promotional',
    restoration: 'Returned',
    correction: 'Correction',
};

/** Movements that take points AWAY from the customer, for a +/− sign. */
export const isDebit = (type) => ['redeem', 'reverse', 'expire'].includes(type);

export const BLOCKED_LABEL = {
    program_inactive: 'Programme not active',
    no_launch_date: 'No launch date set',
    no_order_date: 'No usable order date',
    before_launch: 'Placed before the programme started',
    cancelled: 'Order cancelled',
    rto: 'Returned to origin',
    not_delivered: 'Awaiting delivery',
    payment_unverified: 'Payment not verified',
    cod_not_collected: 'COD not collected',
    no_wallet_key: 'No valid mobile on the order',
    pending: 'Waiting',
    issued: 'Credited',
};
